import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Sizes, Success24Fill, Warning24FillRed } from "@/components/icon/IconList";
import { Snackbar as MuiSnackbar, Typography, styled as muiStyled, useTheme } from "@mui/material";
import { forwardRef, useState } from "react";
import styled from "styled-components";
export const defaultSnackbarProps = {
    autoHideDuration: 3000,
    anchorOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    style: {
        top: 88
    }
};
export const Snackbar = muiStyled(MuiSnackbar)((param)=>{
    let { theme  } = param;
    return {
        ".MuiSnackbarContent-root": {
            minWidth: "unset",
            padding: "12px 16px",
            borderRadius: 8,
            backgroundColor: theme.palette.grey[700],
            ".MuiSnackbarContent-message": {
                padding: 0
            }
        }
    };
});
export const IconWithSnackbarMessage = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { text , icon  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(SnackbarMessage, {
        ref: ref,
        children: [
            icon === "success" && /*#__PURE__*/ _jsx(Typography, {
                color: (theme)=>theme.palette.success.main,
                sx: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: Success24Fill,
                    size: Sizes.medium
                })
            }),
            icon === "warning" && /*#__PURE__*/ _jsx(Icon, {
                icon: Warning24FillRed,
                size: Sizes.medium,
                color: theme.palette.status.error
            }),
            /*#__PURE__*/ _jsx(Typography, {
                component: "div",
                typography: "subtitle1",
                color: theme.palette.blackAndWhite.white,
                children: text
            })
        ]
    });
});
IconWithSnackbarMessage.displayName = "IconWithSnackbarMessage";
const SnackbarMessage = styled.div.withConfig({
    componentId: "sc-cddfc4fa-0"
})(_templateObject());
const useSnackbar = (variants)=>{
    const [isShowSnackbar, setIsShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState({
        icon: null,
        text: ""
    });
    const showSnackbar = (variant)=>{
        if (variant) {
            setSnackbarMessage(variants[variant]);
        }
        setIsShowSnackbar(true);
    };
    const hideSnackbar = ()=>{
        setIsShowSnackbar(false);
    };
    return {
        isShowSnackbar,
        snackbarMessage,
        showSnackbar,
        hideSnackbar
    };
};
export default useSnackbar;
